import { Injectable } from '@angular/core';
import { VuConnectionHttpService } from './vu-connection-http.service';
import { Subject, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class TouchTileService {

  private rfidCardLedEnableChange = new Subject<boolean>();
  private cardDispenserLedChange = new Subject<boolean>();
  private subscription: Subscription;
  private cardDispenserSubscription: Subscription;

  constructor(
    private vuConnectionHttpService: VuConnectionHttpService,
  ) {

    this.subscription = this.rfidCardLedEnableChange
      .pipe(
        switchMap(enable => this.vuConnectionHttpService.touchTileRfidCardLedEnable(enable)),
      )
      .subscribe();
    this.cardDispenserSubscription = this.cardDispenserLedChange.pipe(
      switchMap(enable => this.vuConnectionHttpService.touchTileCardDispenserLedEnable(enable)),
    ).subscribe();
  }

  rfidCardLedEnable(enable: boolean) {
    this.rfidCardLedEnableChange.next(enable);
  }

  cardDispenserEnable(enable: boolean) {
    this.cardDispenserLedChange.next(enable);
  }

  switchLntBoard(enabled: boolean) {
    this.vuConnectionHttpService.switchLntBoard(enabled);
  }
}
